import { AxiosInstance } from 'axios';
import store from '@/store/store';
import { setModalError } from '@/state/general/generalSlice';
import { logoutMember } from '@/state/member/useMember';

const baseResponseInterceptor = (axiosInstance: AxiosInstance) => {
    axiosInstance.interceptors.response.use(
        (resp) => {
            return resp;
        },
        (error = { response: {} }) => {
            try {
                const status = error?.response?.status || null;

                const {
                    general: {
                        errorModal: { isErrorModalVisible },
                    },
                    auth: {
                        tokens: { accessToken },
                    },
                } = store.getState();

                if (status === 500 && !isErrorModalVisible) {
                    if (error?.response?.data) {
                        const {
                            error: errorTitle,
                            message: errorText,
                            statusCode: errorCode,
                        } = error.response.data;

                        store.dispatch(
                            setModalError({
                                isErrorModalVisible: true,
                                errorTitle,
                                errorText,
                                errorCode,
                            }),
                        );
                    }
                }

                if ((status === 401 || status === 499) && accessToken) {
                    return logoutMember(false).then(() => {
                        console.warn('Force Logout');
                        return Promise.reject(error);
                    });
                } else {
                    return Promise.reject(error);
                }
            } catch (error) {
                console.error(error);
            }
        },
    );
};
export default baseResponseInterceptor;
